 <template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>Course</strong>
          </CCardHeader>
              
          <CCardBody>
            <CRow>
              <CCol md="8">
                <CForm>
                  <CInput
                    label="Course Name *"
                    v-model="subject.name"
                    placeholder="Course Name..."
                    horizontal
                    autocomplete="name"
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Course Name'"
                    :is-valid="
                      $v.subject.name.$dirty
                        ? !$v.subject.name.$error
                        : null
                    "
                    @blur="$v.subject.subjectName.$touch()"
                  />
                   <CInput
                    label="Order Code"
                    v-model="subject.orderCode"
                    placeholder="Order of this subject..."
                    horizontal
                    :disabled="mode.viewMode"
                    type="number"
                    :invalid-feedback="'Please Enter the Order'"
                  />

                  <MultiSelect
                    label="Categories"
                    :options="allCategories"
                    @input="updateCategory"
                    :hide-selected="false"
                    :searchable="true"
                    optionLabel="name"
                    :disabled="mode.viewMode"
                    track-by="id"
                    :track-ids.sync="subject.categoryId"
                    idParamName="id"
                    :itemTypeisString="false"
                    invalidFeedback="Select One Categories"

                  ></MultiSelect>
        
                   <MultiSelect
                    label="Stream"
                    :options="categorySpecificStreams"
                     @input="updateStream"
                    :hide-selected="false"
                    :searchable="true"
                    optionLabel="name"
                    :disabled="mode.viewMode"
                    track-by="streamId"
                    :track-ids.sync="subject.streamId"
                    idParamName="streamId"
                    :itemTypeisString="false"
                    invalidFeedback="Select One Stream"
                    :is-valid="
                      $v.subject.streamId.$dirty
                        ? !$v.subject.streamId.$error
                        : null
                    "
                    
                  ></MultiSelect> 
          
                 
              
                 <MultiSelect
                    label="Grades"
                    :options="categorystreamSpecificgrades"
                    :hide-selected="false"
                    :searchable="true"
                    optionLabel="name"
                    :disabled="mode.viewMode"
                    track-by="gradeId"
                    :track-ids.sync="subject.gradeId"
                    idParamName="gradeId"
                    :itemTypeisString="false"
                    invalidFeedback="Select One Grade"
                  ></MultiSelect>
                
                <!-- <div v-if="mode.viewMode"> 
                   <MultiSelect
                   label="Grades"
                    :options="allgrades"
                    :hide-selected="false"
                    :searchable="true"
                    optionLabel="name"
                    :disabled="mode.viewMode"
                    track-by="gradeId"
                    :track-ids.sync="subject.gradeId"
                    idParamName="gradeId"
                    :itemTypeisString="false"
                    invalidFeedback="Select One Grade"
                  ></MultiSelect>
                   </div>  -->
                  <CInput
                    label="Actual Price"
                    v-model="subject.actualPrice"
                    placeholder="Actual Price..."
                    horizontal
                     type="number"
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Actual Price'"
                  />
                  <CInput
                    label="Discount"
                    v-model="subject.discount"
                    placeholder="Discount..."
                    horizontal
                    type="number"
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Discount'"
                  >
                  <template  #description> 
                       Amount 
                  </template>

                  </CInput>
                  <!-- <CInput
                    label="No Of Units"
                    v-model="subject.noOfUnits"
                    placeholder="No Of Units..."
                    horizontal
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Data'"
                  /> -->
                  <!-- <div class="form-group row">
						   <label for="example-text-input text-right" class="col-sm-4 col-form-label">Select Color</label>
						   <div class="col-sm-6"  >  
							<chrome-picker 
                    v-model="subject.backgroundColor"

                  /> </div>
					    </div> -->

                <CInput
                    label="Background color"
                    v-model="subject.backgroundColor"
                    placeholder="Background color..."
                    horizontal
                    disabled
                    :invalid-feedback="'Please Enter Background color'"
                  >
                  <template #prepend> 
                       <v-input-colorpicker class="mr-2 my-1" label="Cover Image Color"  v-model="subject.backgroundColor" />
                  </template>

                  
                  </CInput>

                  <CInputFile
                    label="Select Icon"
                    horizontal
                    type="file"
                    :disabled="mode.viewMode"
                    accept="image/*"
                    @change="uploadImage"
                    :is-valid="
                      $v.subject.iconId.$dirty
                        ? !$v.subject.iconId.$error
                        : null
                    "
                    @blur="$v.subject.iconId.$touch()"
                  >
                  <template  #description> 
                      Size of Image Should be 240x240 
                  </template>
                  </CInputFile>
                  <!-- invalid-feedback="Please upload the Image"
                  
                  :is-valid="$v.subject.iconId.$dirty? !$v.subject.iconId.$error  : null"
                  @blur="$v.subject.iconId.$touch()" -->
                  <CRow>
                    <CCol md="3"></CCol>
                    <CCol md="9" align="center">
                      <CCard
                        v-if="subject.iconId && !$v.subject.iconId.$error"
                        style="margin-top: 20px"
                      >
                        <CCardBody align="center">
                          <CButton
                            color="danger"
                            style="float: right"
                            @click="removeimage()"
                             :disabled="mode.viewMode"
                          >
                            <CIcon
                              name="cilXCircle"
                              description="Delete"
                            ></CIcon>
                          </CButton>
                          <CImg
                            v-if="subject.iconId"
                            :src="imageUrl(subject.iconId)"
                            height="180px"
                            alt="Responsive image"
                            :disabled="mode.viewMode"
                          >
                          </CImg>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  </CRow>
                </CForm>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter align="right">
            <CButton
              class="mr-2"
              v-if="mode.viewMode"
              type="submit"
              color="secondary"
              @click="editMode()"
              >Edit</CButton
            >
            <CButton
              class="mr-2"
              v-if="!mode.viewMode"
              type="submit"
              color="success"
              @click="saveSubject()"
              >Save</CButton
            >
            <CButton class="mr-2" type="Cancel" color="danger" @click="cancel()"
              >Cancel</CButton
            >
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Vue from "vue";
import MultiSelect from "../../containers/MultiSelect";
import InputColorPicker from "vue-native-color-picker";
Vue.use(InputColorPicker);

import {
  required,
  minLength,
  maxLength,
  url,
  requiredIf,
} from "vuelidate/lib/validators";
export default {
  name: "Course",
  components: {
    MultiSelect,
  
    "v-input-colorpicker": InputColorPicker,
  },
  data() {
    return {
      mode: {
        newMode: false,
        editMode: false,
        viewMode: false,
      },
      courseId: "",
      color: "#0f4c81",
      subject: {
        categoryId:"",
        name: "",
        actualPrice: "",
        discount: "",
        courseId: "",
        streamId: "",
        subStreams: [],
        subcourseStream: [],
        noOfUnits: "",
        iconId: "",
        orderCode:0,
        backgroundColor: "",
        gradeId:"",
      },
      allCategories: [],
      allStreams: [],
      allgrades:[],
      categorySpecificStreams: [],
      categorystreamSpecificgrades:[],
    };
  },
  validations: {
    subject: {
      name: {
        required,
      },
      streamId: {
        required, 
      },
      //     actualPrice:{
      //            required,
      //       },
      //       discount:{
      //            required,
      //       },
      //       backgroundColor:{
      //          required,
      //       },
      //  noOfUnits:{
      //          required,
      //       }
      iconId: {
        // required,
      },
    },
  },
  created() {
    if (this.$route.params.mode == "new") {
      this.mode.newMode = true;
      this.mode.viewMode = false;
      this.mode.editMode = false;
    }
    if (this.$route.params.mode == "view") {
      this.mode.viewMode = true;
      this.courseId = this.$route.params.courseId;
      this.getSubject();
    } else if (this.$route.params.mode == "edit") {
      this.mode.editMode = true;
      this.courseId = this.$route.params.courseId;
      this.getSubject();
    }
  },
  methods: {
    imageUrl(iconId) {
      console.log(iconId);
      return process.env.VUE_APP_API_HOST + "/file/" + iconId;
    },

    removeimage() {
      this.subject.iconId = "";
    },
    uploadImage(files, event) {
      const URL = process.env.VUE_APP_API_HOST + "/file/upload";
      console.log("uploadImage", URL);
      console.log("files", files);
      console.log("event", event);
      let fdata = new FormData();
      fdata.append("file", files[0]);

      // fdata.append("courseId","courseId");
      fdata.append("iconId", "fileId");

      fetch(URL, {
        method: "POST",
        body: fdata,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("image upload response > ", data);
          // this.service.image = data.data.fileId;

          this.subject.iconId = data.data.fileId;
        });
    },
    // updateValue(colors){
    //   console.log("colors", colors);
    //   //this.subject.backgroundColor=colors;
    // },
    editMode() {
      this.mode.editMode = true;
      this.mode.viewMode = false;
      this.editupdateStream();
      
    },
     editupdateStream(){
       console.log("update stream called");
       var self = this;
       var models =  self.allStreams.filter(function(strem){
            	return self.subject.categoryId ==strem.categoryId;
            });
            self.models =[];
           console.log(models);
            self.categorySpecificStreams= models;
      
      	var model =  self.allgrades.filter(function(grade){
            	return 	self.subject.streamId == grade.streamId;
            });
            self.model =[];
           console.log(model);
            self.categorystreamSpecificgrades= model;


     },
    cancel() {
      this.$router.push({ name: "Courses" });
    },

    getSubject() {
      this.apiGetSecure(
        process.env.VUE_APP_API_HOST + "/web/secure/subject/" + this.courseId
      )
        .then((response) => response.json())
        .then((data) => (this.subject = data));
    },
    // updateCategory() {
    //   var self = this;

    //   self.subject.courseId = data.courseId;
    //   //console.log(self.bookingResponse.brandId);
    //   self.subject.streamId = data.streamId;
    //   var allStreams = self.allStreams.filter(function (model) {
    //     return data.courseId == model.courseId;
    //   });
    //   self.allStreams = [];
    //   // console.log(models);
    //   self.categorySpecificSubcategory = allStreams;
    //   //self.getServicesByBrandAndModel(data.categoryId,data.subCategoryId);
    //   console.log(categorySpecificStreams);
    // },

    // getsubcourseStreamByCourse(courseId) {
    //   return this.allStreams.filter(function (model) {
    //     return courseId == model.courseId;
    //   });
    // },

    	updateCategory(data){
        	var self = this;
        	self.subject.categoryId = data.id;
        	console.log(self.subject.categoryId);
        	self.subject.streamId = data.streamId;
        	var models =  self.allStreams.filter(function(strem){
            	return data.id ==strem.categoryId;
            });
            self.models =[];
           console.log(models);
            self.categorySpecificStreams= models;
            self.categorystreamSpecificgrades= models;
      
        },   
        updateStream(data){
        	var self = this;
        	self.subject.streamId = data.streamId;
        	console.log(self.subject.streamId);
        	self.subject.gradeId = data.gradeId;
        	var model =  self.allgrades.filter(function(grade){
            	return data.streamId == grade.streamId;
            });
            self.model =[];
           console.log(model);
            self.categorystreamSpecificgrades= model;
        },
    getCategories() {
      this.apiGetSecure(process.env.VUE_APP_API_HOST + "/web/secure/courses")
        .then((response) => response.json())
        .then((data) => (this.allCategories = data));
      console.log(this.allCategories);
    },
    getStreams() {
      this.apiGetSecure(
        process.env.VUE_APP_API_HOST + "/web/secure/all/course_streams"
      )
        .then((response) => response.json())
        .then((data) => {this.allStreams = data;
        this.categorySpecificStreams = data;});
    },
getGrades() {
      this.apiGetSecure(process.env.VUE_APP_API_HOST + "/web/secure/all/grades")
        .then((response) => response.json())
        .then((data) => {this.allgrades = data;
       this.categorystreamSpecificgrades = data; });
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    },

    saveSubject() {
      this.$v.subject.$touch();
      if (this.$v.subject.$invalid) {
        console.log("form is invalid", JSON.stringify(this.$v.subject));
      } else {
        this.apiPostSecure(
          process.env.VUE_APP_API_HOST + "/web/secure/save/subject",
          this.subject
        ).then((post) => {
          this.$router.push({ name: "Courses" });
        });
      }
    },
  },
  mounted() {
    this.getCategories();
    this.getStreams();
  this.getGrades();
  },
};
</script>
<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>

